/**
 * @generated SignedSource<<3b902d79dbb4a68398847ba45ea0f789>>
 * @relayHash 76ff2617e25b64e40a9f40d8514a44bf
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 76ff2617e25b64e40a9f40d8514a44bf

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type de_BetterDocExchangeOperation = "CONFIRM_RECOMMENDATION_RESULTS" | "CONFIRM_SELECTED_MEDICS" | "CREATE_RECOMMENDATION" | "GET_RECOMMENDATION" | "LIST_RECOMMENDATIONS" | "LIST_RECOMMENDED_RECOMMENDATIONS" | "LIST_SELECTED_RECOMMENDATIONS" | "SEARCH_CARE_PROVIDERS" | "SELECT_MEDIC" | "SEND_REFERRAL_SLIP" | "SIMULATE_PATIENT_SELECTION" | "SIMULATE_RESEARCH" | "SIMULATE_SECOND_OPINION_VISIT_CONFIRMATION";
export type de_BetterDocExchangeOutcome = "CANCELLED" | "FAILED" | "PENDING" | "RESPONDED" | "TIMED_OUT" | "TOKEN_UNAVAILABLE";
export type de_BetterDocNavigationType = "MSN" | "NO_NAVIGATION" | "PMN";
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocSessionStepType = "CREDENTIALS_REJECTED" | "EXISTING_RECOMMENDATION_RECEIVED" | "MSN_RECOMMENDATION_PENDING" | "NO_NAVIGATION_RECEIVED" | "PATIENT_SELECTION_REQUESTED" | "PMN_RECOMMENDATION_RECEIVED" | "RATE_LIMITED" | "RECOMMENDATION_NOT_FOUND" | "RECOMMENDATION_REQUESTED" | "REFERRAL_SLIP_SENT" | "REQUEST_FAILED" | "RESEARCH_REQUESTED" | "SECOND_OPINION_VISIT_CONFIRMATION_REQUESTED" | "UNEXPECTED_RESPONSE" | "VALIDATION_REJECTED";
export type de_BetterDocTestCaseScenario = "MSN" | "MSN_WITH_SECOND_OPINION" | "PMN";
export type betterDocSessionQuery$variables = {
  sessionId: number;
};
export type betterDocSessionQuery$data = {
  readonly de_betterDocSession: {
    readonly exchanges: ReadonlyArray<{
      readonly actor: string;
      readonly durationMilliseconds: number | null;
      readonly exchangeId: number;
      readonly failureKind: string | null;
      readonly hasUnexpectedResponse: boolean;
      readonly httpMethod: string;
      readonly isTestCase: boolean;
      readonly operation: de_BetterDocExchangeOperation;
      readonly outcome: de_BetterDocExchangeOutcome;
      readonly requestUri: any;
      readonly responseStatusCode: number | null;
      readonly startedAt: string;
    }>;
    readonly recommendedMedics: ReadonlyArray<{
      readonly payload: string;
      readonly position: number;
      readonly receivedAt: string;
      readonly receivedInExchangeId: number;
      readonly recommendedMedicId: number;
      readonly selectionId: number;
    }>;
    readonly session: {
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly caseId: string | null;
      readonly createdAt: string;
      readonly createdBy: string;
      readonly insuranceCountry: Country | null;
      readonly isTestCase: boolean;
      readonly navigationType: de_BetterDocNavigationType | null;
      readonly partnerPatientId: string;
      readonly partnerSessionId: string;
      readonly progressNoteId: number | null;
      readonly recommendationId: string | null;
      readonly sessionId: number;
      readonly testCaseScenario: de_BetterDocTestCaseScenario | null;
      readonly updatedAt: string;
    };
    readonly steps: ReadonlyArray<{
      readonly actor: string;
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly detail: string | null;
      readonly exchangeId: number | null;
      readonly isUnchanged: boolean;
      readonly occurredAt: string;
      readonly stepId: number;
      readonly type: de_BetterDocSessionStepType;
    }>;
  } | null;
};
export type betterDocSessionQuery = {
  response: betterDocSessionQuery$data;
  variables: betterDocSessionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTestCase",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "betterDocState",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actor",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeId",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      }
    ],
    "concreteType": "de_BetterDocSessionDetail",
    "kind": "LinkedField",
    "name": "de_betterDocSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocSessionSummary",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerPatientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressNoteId",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "testCaseScenario",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "navigationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insuranceCountry",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "caseId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocSessionStep",
        "kind": "LinkedField",
        "name": "steps",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stepId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occurredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUnchanged",
            "storageKey": null
          },
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "detail",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocRecommendedMedic",
        "kind": "LinkedField",
        "name": "recommendedMedics",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendedMedicId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "position",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "selectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receivedInExchangeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receivedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocExchangeSummary",
        "kind": "LinkedField",
        "name": "exchanges",
        "plural": true,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "operation",
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "httpMethod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestUri",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasUnexpectedResponse",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatusCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationMilliseconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "outcome",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failureKind",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocSessionQuery",
    "selections": (v5/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocSessionQuery",
    "selections": (v5/*:: as any*/)
  },
  "params": {
    "id": "76ff2617e25b64e40a9f40d8514a44bf",
    "metadata": {},
    "name": "betterDocSessionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d1f9533c7cf49dc17a5ddb450b0e8511";

export default node;
